<template>
  <v-dialog v-model="show" persistent no-click-animation width="500">
    <v-card class="review-dialog" elevation="0">
      <div class="review-header pa-6 pb-4">
        <div class="d-flex align-center">
          <v-icon color="white" size="24" class="mr-3"
            >mdi-alert-circle-outline</v-icon
          >
          <div>
            <div class="white--text text-h6 font-weight-bold">
              Fields Require Review
            </div>
            <div class="white--text text-body-2" style="opacity: 0.8;">
              Some extracted values need your attention.
            </div>
          </div>
        </div>
      </div>

      <v-card-text class="pa-6">
        <p class="text-body-2 lucky-point--text mb-4">
          The following fields were extracted with low confidence. Please review
          and confirm their values in the next step before submitting.
        </p>

        <div class="field-chips">
          <v-chip
            v-for="(field, i) in fields"
            :key="i"
            small
            class="field-chip ma-1"
            color="#fff3f3"
            text-color="red darken-2"
          >
            <v-icon left x-small color="red darken-2">mdi-flag-outline</v-icon>
            {{ field }}
          </v-chip>
        </div>
      </v-card-text>

      <v-divider />

      <v-card-actions class="pa-4 d-flex justify-end">
        <v-btn
          depressed
          color="fern"
          dark
          class="text-capitalize font-weight-medium px-8"
          @click="dismiss"
        >
          Got It, Continue
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "AutofillReviewNoticeDialog",
  props: {
    value: { type: Boolean, default: false },
    fields: { type: Array, default: () => [] }
  },
  computed: {
    show: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      }
    }
  },
  methods: {
    dismiss() {
      this.show = false;
      this.$emit("continue");
    }
  }
};
</script>

<style lang="scss" scoped>
.review-dialog {
  border-radius: 12px;
  overflow: hidden;
}

.review-header {
  background: linear-gradient(135deg, #1d285c 0%, #2d3a7a 100%);
}

.field-chips {
  display: flex;
  flex-wrap: wrap;
  margin: -4px;
  padding: 12px;
  background-color: #fafafa;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
}

.field-chip {
  font-size: 12px !important;
  height: 26px !important;
}
</style>
